$('#packing-finish-button').on('click', function () {
    if ($(this).hasClass('disabled')) {
        return;
    }
    const salesOrderLineId = $(this).data('sales-order-line-id');
    const batchId = $(this).data('batch-id');
    let confirmMessage = $(this).data('confirm-message');
    confirm(confirmMessage);
    const finishButton = document.getElementById('js-confirm-modal').querySelector('.confirm');
    finishButton.addEventListener('click', function (event) {
        $.ajax({
            type: "GET",
            url: '/admin/production/sales-order-line/packaging/' + salesOrderLineId + '/batch/' + batchId + '/packaged',
            encode: true,
            success: function (data) {
                location.reload();
                },
            error: function (response) {
                if (response.error !== undefined) {
                    alert(response.error);
                } else {
                    alert(JSON.parse(response.responseText).message);
                }
                return false;
            }
        })
    });
});

$('button.production-done').off('click keydown').on('click keydown', function () {
    let btn = $(this);
    $.ajax({
        type: "GET",
        url: btn.attr('data-route'),
        data: null,
        dataType: "json",
        encode: true,
        success: function () {
            btn.prop('disabled', 'disabled');
            document.location.reload();
        },
        error: function (response) {
        }
    });
});
$('button.packaging-done').off('click keydown').on('click keydown', function () {
    let btn = $(this);
    $.ajax({
        type: "GET",
        url: btn.attr('data-route'),
        data: null,
        dataType: "json",
        encode: true,
        success: function () {
            btn.prop('disabled', 'disabled');
            document.location.reload();
        },
        error: function (response) {
        }
    });
});
